module.exports = __webpack_public_path__ + "static/technology_services-a6e503b73c5e4a1782b802b16e0a2486.jpg";